import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogin: reactLocalStorage.getObject('user.info') ? true : false,
    };
  }

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json['names'].length; i++) {
      var type = 'fa fa-circle text-' + json['types'][i];
      legend.push(<i className={type} key={i} />);
      legend.push(' ');
      legend.push(json['names'][i]);
    }
    return legend;
  }
  render() {
    if (!this.state.isLogin) {
      return <Redirect push to="/login" />;
    }
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col lg={3} sm={6}></Col>
            <Col lg={3} sm={6}></Col>
            <Col lg={3} sm={6}></Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Home;
